import React, { useEffect, useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function HeroSection() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    setIsVisible(true);
  }, []);
  return <section className="relative h-screen w-full overflow-hidden bg-black" data-id="element-65">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/7BXLxxcQfAnE5h94PfhqjS/kover_cisto_taprva_slika_namesto_vesolja.jpg")',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      filter: 'brightness(0.6)'
    }} data-id="element-66" />

      {/* Overlay Gradient */}
      <div className="absolute inset-0 z-10 bg-gradient-to-b from-black/30 via-transparent to-black/80" data-id="element-67" />

      {/* Content */}
      <div className="relative z-20 flex h-full flex-col items-center justify-center px-4 text-center text-white" data-id="element-68">
        <div className={`transition-all duration-1000 ease-out ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`} data-id="element-69">
          <h2 className="mb-4 text-sm font-medium tracking-[0.3em] text-neutral-300 uppercase" data-id="element-70">
            Photography Portfolio
          </h2>
          <h1 className="mb-6 text-5xl tracking-tight sm:text-7xl md:text-8xl lg:text-9xl" data-id="element-71">
            <span className="font-light" data-id="element-72">DREAM</span>
            <span className="font-bold" data-id="element-73">BIG</span>
          </h1>
          <p className="mx-auto max-w-lg text-lg font-light text-neutral-300 sm:text-xl" data-id="element-74">
            Capturing the raw beauty of moments in their purest form.
          </p>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className={`absolute bottom-10 left-1/2 z-20 -translate-x-1/2 transition-opacity duration-1000 delay-700 ${isVisible ? 'opacity-100' : 'opacity-0'}`} data-id="element-75">
        <div className="flex flex-col items-center gap-2 animate-bounce" data-id="element-76">
          <span className="text-[10px] uppercase tracking-widest text-neutral-400" data-id="element-77">
            Scroll
          </span>
          <ChevronDown className="h-5 w-5 text-white" data-id="element-78" />
        </div>
      </div>
    </section>;
}